$(".js-art_tabInputArea").on('DOMNodeInserted', function(e) {
  $("#ajax-sample-html-tab .js-file-input").on("change", function() {
    let file = this.files[0];
    let fr = new FileReader();
    fr.onload = function () {
      postImage(fr.result, file.name, "#ajax-sample-html-tab")
    }

    fr.readAsDataURL(file)
  })
});

$(".js-file-input").on("change", function() {
  if ($(this).hasClass('no-ajax')) {
    return true // ファイル名のテキストを更新したいのでtrue
  }
  let file = this.files[0];
  let fr = new FileReader();
  fr.onload = function () {
    postImage(fr.result, file.name, "#ajax-sample-free-image")
  }

  fr.readAsDataURL(file)
})

function postImage(image, fileName, area) {
  $.ajax({
    type: "POST",
    url: "http://localhost:3000/images",
    contentType: "application/json",
    data: JSON.stringify({ "image": image, "fileName": fileName }),
    success: function(res) {
      let lastImage = $(" .c-fileupload_pic img:last", area);
      lastImage.prop("data-id", res.id);
      lastImage.prop("data-filename", res.fileName);
      lastImage.prop("data-image", res.image);

      $(".js-file-openPrev", area).html("/article/image/" + res.id)
      lastImage.on("click", function(){
        let img = $(this);
        $("#ajax-sample-image-id").html(img.prop("data-id"))
        $("#ajax-sample-file-name").val(img.prop("data-filename"))
        $("#ajax-sample-image").prop("src", img.prop("data-image"))
      })
    },
    error: function(response){
      alert("画像登録に失敗しました。")
    }
  });
}
